import { createContext, memo, useContext, useMemo } from "react"

import { useSortable } from "@dnd-kit/sortable"

import { CSS } from "@dnd-kit/utilities"

import { DragIndicator } from "@mui/icons-material"

import "./SortableItem.css"

const SortableItemContext = createContext({
  attributes: {},
  listeners: undefined,
  ref() { }
})

function SortableItemComponent({ children, id, style: propStyle }) {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition
  } = useSortable({
    id,
    transition: {
      duration: 500,
      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
    }
  })

  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref: setActivatorNodeRef
    }),
    [attributes, listeners, setActivatorNodeRef]
  )

  const style = {
    ...propStyle,
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition
  }

  return (
    <SortableItemContext.Provider value={context}>
      <div ref={setNodeRef} style={style}>
        {children}
      </div>
    </SortableItemContext.Provider>
  )
}

export const SortableItem = memo(SortableItemComponent)

export function DragHandle(props) {
  const { attributes, listeners, ref } = useContext(SortableItemContext)

  return (
    <div
      className="DragHandle transition"
      {...attributes}
      {...listeners}
      ref={ref}
      style={{
        ...props.fontSize === "small" && {
          width: "8px",
          padding: "4px 8px"
        }
      }}
    >
      <DragIndicator fontSize={props.fontSize || "medium"} />
    </div>
  )
}
